export default __webpack_public_path__ + "static/media/sitting-lady.d5609fee.svg";